(() => {
  if (window.MomanteeGiftCustomizerLoaded) return;
  window.MomanteeGiftCustomizerLoaded = true;

  const MARKER = '[MOMANTEE_GIFT_V1]';

  const createRequestId = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return `gift_${window.crypto.randomUUID()}`;
    }

    return `gift_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  };

  const bindCustomizer = (root) => {
    if (!root || root.dataset.giftCustomizerBound === 'true') return;

    const formId = root.dataset.formId;
    const form = document.getElementById(formId) || root.closest('form');
    if (!form) return;

    root.dataset.giftCustomizerBound = 'true';

    const noteToggle = root.querySelector('[data-gift-note-toggle]');
    const messageWrapper = root.querySelector('[data-gift-message-wrapper]');
    const textarea = root.querySelector('[data-gift-message-textarea]');
    const charCount = root.querySelector('[data-gift-char-count]');
    const requestInput = root.querySelector('[data-gift-request-id-input]');
    const servicesInput = root.querySelector('[data-gift-services-input]');
    const markerInput = root.querySelector('[data-gift-marker-input]');
    const toggles = Array.from(root.querySelectorAll('[data-gift-option-toggle]'));
    const suggestionButtons = Array.from(root.querySelectorAll('[data-gift-message-suggestion]'));
    const suggestionTabs = Array.from(root.querySelectorAll('[data-gift-suggestion-tab]'));
    const suggestionPanels = Array.from(root.querySelectorAll('[data-gift-suggestion-panel]'));
    const infoDialog = root.querySelector('[data-gift-info-dialog]');
    const infoOpenButton = root.querySelector('[data-gift-info-open]');
    const infoCloseButtons = Array.from(root.querySelectorAll('[data-gift-info-close]'));
    const demoFrame = infoDialog ? infoDialog.querySelector('[data-gift-demo-frame]') : null;
    const demoRoot = infoDialog ? infoDialog.querySelector('[data-gift-demo]') : null;
    const demoVideo = infoDialog ? infoDialog.querySelector('.momantee-gift-customizer__demo-video') : null;

    const buildEmbedUrl = (value) => {
      const rawUrl = String(value || '').trim();
      if (!rawUrl) return '';

      try {
        const url = new URL(rawUrl);
        const host = url.hostname.replace(/^www\./, '');

        if (host === 'youtu.be') {
          const id = url.pathname.replace(/^\/+/, '').split('/')[0];
          return id ? `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1` : rawUrl;
        }

        if (host === 'youtube.com' || host === 'm.youtube.com') {
          const watchId = url.searchParams.get('v');
          if (watchId) return `https://www.youtube.com/embed/${watchId}?rel=0&modestbranding=1`;

          const parts = url.pathname.split('/').filter(Boolean);
          const embedIndex = parts.indexOf('embed');
          const shortsIndex = parts.indexOf('shorts');
          let id = '';
          if (embedIndex >= 0) {
            id = parts[embedIndex + 1];
          } else if (shortsIndex >= 0) {
            id = parts[shortsIndex + 1];
          }
          return id ? `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1` : rawUrl;
        }

        if (host === 'vimeo.com' || host === 'player.vimeo.com') {
          const parts = url.pathname.split('/').filter(Boolean);
          const id = parts[0] === 'video' ? parts[1] : parts[0];
          return id ? `https://player.vimeo.com/video/${id}` : rawUrl;
        }

        return rawUrl;
      } catch (error) {
        return rawUrl;
      }
    };

    const loadDemoVideo = () => {
      if (!demoFrame || !demoRoot || demoFrame.getAttribute('src')) return;
      const embedUrl = buildEmbedUrl(demoRoot.dataset.giftDemoUrl);
      if (embedUrl) {
        demoFrame.setAttribute('src', embedUrl);
      }
    };

    const unloadDemoVideo = () => {
      if (demoFrame) {
        demoFrame.removeAttribute('src');
      }

      if (demoVideo && typeof demoVideo.pause === 'function') {
        demoVideo.pause();
      }
    };

    const openInfoDialog = () => {
      if (!infoDialog) return;
      loadDemoVideo();

      if (typeof infoDialog.showModal === 'function') {
        infoDialog.showModal();
        return;
      }

      infoDialog.setAttribute('open', '');
    };

    const closeInfoDialog = () => {
      if (!infoDialog) return;

      if (typeof infoDialog.close === 'function' && infoDialog.open) {
        infoDialog.close();
        return;
      }

      infoDialog.removeAttribute('open');
      unloadDemoVideo();
    };

    const getSelectedLabels = () => toggles
      .filter((toggle) => toggle.checked)
      .map((toggle) => toggle.dataset.giftServiceLabel || '')
      .filter(Boolean);

    const syncGiftMetadata = () => {
      const labels = getSelectedLabels();

      if (!labels.length) {
        root.dataset.giftRequestId = '';
        if (requestInput) requestInput.value = '';
        if (servicesInput) servicesInput.value = '';
        if (markerInput) markerInput.value = '';
        return;
      }

      const existingId = root.dataset.giftRequestId || (requestInput ? requestInput.value : '');
      const requestId = existingId || createRequestId();
      root.dataset.giftRequestId = requestId;

      if (requestInput) requestInput.value = requestId;
      if (servicesInput) servicesInput.value = labels.join(', ');
      if (markerInput) markerInput.value = MARKER;
    };

    const updateCharCount = () => {
      if (!textarea || !charCount) return;

      const maxLength = Number(textarea.getAttribute('maxlength')) || 0;
      const currentLength = textarea.value.length;
      charCount.textContent = maxLength ? `${currentLength} / ${maxLength}` : String(currentLength);
      charCount.classList.toggle('is-warning', maxLength > 0 && currentLength >= Math.floor(maxLength * 0.9));
    };

    const syncNoteState = () => {
      if (!noteToggle || !messageWrapper || !textarea) return;

      const isActive = noteToggle.checked;
      messageWrapper.hidden = !isActive;
      textarea.disabled = !isActive;

      if (!isActive) {
        textarea.value = '';
        updateCharCount();
      }
    };

    const syncAll = () => {
      syncNoteState();
      syncGiftMetadata();
      root.dispatchEvent(new CustomEvent('momantee:gift:change', { bubbles: true }));
    };

    toggles.forEach((toggle) => {
      toggle.addEventListener('change', syncAll);
    });

    if (textarea) {
      textarea.addEventListener('input', () => {
        updateCharCount();
        syncGiftMetadata();
      });
    }

    suggestionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!textarea) return;
        textarea.value = button.dataset.giftMessageSuggestion || '';
        textarea.focus();
        updateCharCount();
        syncGiftMetadata();
      });
    });

    suggestionTabs.forEach((button) => {
      button.addEventListener('click', () => {
        const panelId = button.dataset.giftSuggestionTarget;

        suggestionTabs.forEach((tab) => {
          tab.setAttribute('aria-selected', tab === button ? 'true' : 'false');
        });

        suggestionPanels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });
      });
    });

    if (infoOpenButton && infoDialog) {
      infoOpenButton.addEventListener('click', openInfoDialog);
      infoCloseButtons.forEach((button) => {
        button.addEventListener('click', closeInfoDialog);
      });

      infoDialog.addEventListener('click', (event) => {
        if (event.target === infoDialog) {
          closeInfoDialog();
        }
      });

      infoDialog.addEventListener('close', unloadDemoVideo);
    }

    form.addEventListener('submit', () => {
      if (textarea) {
        textarea.value = textarea.value.trim();
      }

      syncGiftMetadata();
    }, true);

    syncAll();
    updateCharCount();
  };

  const initGiftCustomizer = (context) => {
    const scope = context && context.querySelectorAll ? context : document;
    scope.querySelectorAll('[data-momantee-gift-customizer]').forEach(bindCustomizer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGiftCustomizer(document));
  } else {
    initGiftCustomizer(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initGiftCustomizer(event.target);
  });
})();
